import { useTranslation } from 'react-i18next';

const LocalizationPlainText = (text, nameSpace) => {
    const { t } = useTranslation(nameSpace, {  useSuspense: false });

    return t(text);
}

export default LocalizationPlainText;
